export function accessCodeNormalize(accessCode: string) {
  // const code = accessCode?.replace(/^([0-9]{3})([0-9]{2})([0-9]{4})$/,
  //   '$1-$2-$3',);
  // return code;
  return accessCode;
}
